<section #editableGroup>
  <details *ngFor="let item of viewModelGroups[0]"
           thema-core-expansion>
    <summary [class]=[CLASSES.EDITABLE_ITEM]></summary>
    <p [class]=[CLASSES.EDITABLE_ITEM]></p>
  </details>
</section>
